import React from 'react';

import { loaderGif } from '../../../assets/images/login';
import styles from '../../../features/formAfterSignUp/FormAfterSignUp.module.css';
import { TDirectorInfo } from '../../../types';

type TProps = {
  showModal?: boolean;
  setShowModal?: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  shareholders: TDirectorInfo[];
  sharesAllocated: number;
};
export default function BreakdownModal({
  showModal = false,
  setShowModal = () => {
    return;
  },
  title,
  shareholders,
  sharesAllocated,
}: TProps) {
  return (
    <>
      {showModal ? (
        <>
          <div className='fixed inset-0 z-10 overflow-y-auto'>
            <div
              className='fixed inset-0 w-full h-full bg-black opacity-40'
              onClick={() => setShowModal(false)}
            ></div>
            <div className='flex items-center min-h-screen px-6 py-4'>
              <div className='relative p-[2em] mx-auto bg-[whitesmoke] rounded-md shadow-lg'>
                <div className='flex justify-between items-center pb-2 border-b-2 border-[#000000]'>
                  <div className='text-[#028789] font-[600]'>{title}</div>
                  <div
                    onClick={() => setShowModal(false)}
                    className='py-2 px-3 bg-[#028789] text-white cursor-pointer hover:font-[600] hover:bg-[#E2AB19]'
                  >
                    X
                  </div>
                </div>

                <div className='w-full mt-[1.5em] max-w-[315px] lg:max-w-[700px] sm:flex justify-center'>
                  <div className='w-full text-center sm:text-left'>
                    <div className='border-b-2 border-[#000000] mb-3 pb-3'>
                      {shareholders?.map((shareholder, index) => (
                        <div
                          key={shareholder?.email + shareholder?.identityNumber}
                          className='bg-[#F1F1F1] py-2 px-3 flex justify-between items-center gap-4 mb-1 text-[10px] font-[600]'
                        >
                          <div className='text-[#028789]'>
                            {`${shareholder?.firstName} ${shareholder?.lastName}`.toUpperCase()}
                          </div>
                          <div className=''>{`Alloted Shares (${shareholder?.share}%) = ${(
                            Number(shareholder?.share) * 10000
                          ).toLocaleString()}`}</div>
                        </div>
                      ))}
                    </div>
                    <div className='w-full flex justify-between items-center bg-[#F8B40036] p-3 text-[10px] font-[600]'>
                      <div>{`Total Shares alloted`}</div>
                      <div>{`${(
                        sharesAllocated * 10000
                      ).toLocaleString()}(${sharesAllocated}%)`}</div>
                    </div>

                    <div className='w-full mt-2 flex justify-between items-center bg-[#02878921] p-3 text-[10px] font-[600]'>
                      <div>{`Total Shares remaining`}</div>
                      <div>{`${((100 - sharesAllocated) * 10000).toLocaleString()}(${
                        100 - sharesAllocated
                      }%)`}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
